// Ce fichier est généré automatiquement par utils/placeholder-generator
// Ne pas modifier manuellement

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const PlaceholdersSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'placeholders-idle',
    metadata: {
      frames: {
        'placeholders-idle-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-1': {
          frame: {
            x: 120,
            y: 0,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-2': {
          frame: {
            x: 240,
            y: 0,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-3': {
          frame: {
            x: 360,
            y: 0,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-4': {
          frame: {
            x: 480,
            y: 0,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-5': {
          frame: {
            x: 600,
            y: 0,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-6': {
          frame: {
            x: 720,
            y: 0,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-7': {
          frame: {
            x: 840,
            y: 0,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-8': {
          frame: {
            x: 960,
            y: 0,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-9': {
          frame: {
            x: 1080,
            y: 0,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-left-0': {
          frame: {
            x: 0,
            y: 120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-left-1': {
          frame: {
            x: 120,
            y: 120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-left-2': {
          frame: {
            x: 240,
            y: 120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-left-3': {
          frame: {
            x: 360,
            y: 120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-left-4': {
          frame: {
            x: 480,
            y: 120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-left-5': {
          frame: {
            x: 600,
            y: 120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-left-6': {
          frame: {
            x: 720,
            y: 120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-left-7': {
          frame: {
            x: 840,
            y: 120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-left-8': {
          frame: {
            x: 960,
            y: 120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-bottom-left-9': {
          frame: {
            x: 1080,
            y: 120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-left-0': {
          frame: {
            x: 0,
            y: 240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-left-1': {
          frame: {
            x: 120,
            y: 240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-left-2': {
          frame: {
            x: 240,
            y: 240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-left-3': {
          frame: {
            x: 360,
            y: 240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-left-4': {
          frame: {
            x: 480,
            y: 240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-left-5': {
          frame: {
            x: 600,
            y: 240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-left-6': {
          frame: {
            x: 720,
            y: 240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-left-7': {
          frame: {
            x: 840,
            y: 240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-left-8': {
          frame: {
            x: 960,
            y: 240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-left-9': {
          frame: {
            x: 1080,
            y: 240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-left-0': {
          frame: {
            x: 0,
            y: 360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-left-1': {
          frame: {
            x: 120,
            y: 360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-left-2': {
          frame: {
            x: 240,
            y: 360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-left-3': {
          frame: {
            x: 360,
            y: 360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-left-4': {
          frame: {
            x: 480,
            y: 360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-left-5': {
          frame: {
            x: 600,
            y: 360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-left-6': {
          frame: {
            x: 720,
            y: 360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-left-7': {
          frame: {
            x: 840,
            y: 360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-left-8': {
          frame: {
            x: 960,
            y: 360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-left-9': {
          frame: {
            x: 1080,
            y: 360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-0': {
          frame: {
            x: 0,
            y: 480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-1': {
          frame: {
            x: 120,
            y: 480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-2': {
          frame: {
            x: 240,
            y: 480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-3': {
          frame: {
            x: 360,
            y: 480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-4': {
          frame: {
            x: 480,
            y: 480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-5': {
          frame: {
            x: 600,
            y: 480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-6': {
          frame: {
            x: 720,
            y: 480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-7': {
          frame: {
            x: 840,
            y: 480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-8': {
          frame: {
            x: 960,
            y: 480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-idle-top-9': {
          frame: {
            x: 1080,
            y: 480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
      },
      meta: {
        image: '/sprites/placeholders/placeholders.png',
        size: {
          w: 1200,
          h: 600,
        },
        scale: '1',
      },
      animations: {
        'placeholders-idle-bottom': [
          'placeholders-idle-bottom-0',
          'placeholders-idle-bottom-1',
          'placeholders-idle-bottom-2',
          'placeholders-idle-bottom-3',
          'placeholders-idle-bottom-4',
          'placeholders-idle-bottom-5',
          'placeholders-idle-bottom-6',
          'placeholders-idle-bottom-7',
          'placeholders-idle-bottom-8',
          'placeholders-idle-bottom-9',
        ],
        'placeholders-idle-bottom-left': [
          'placeholders-idle-bottom-left-0',
          'placeholders-idle-bottom-left-1',
          'placeholders-idle-bottom-left-2',
          'placeholders-idle-bottom-left-3',
          'placeholders-idle-bottom-left-4',
          'placeholders-idle-bottom-left-5',
          'placeholders-idle-bottom-left-6',
          'placeholders-idle-bottom-left-7',
          'placeholders-idle-bottom-left-8',
          'placeholders-idle-bottom-left-9',
        ],
        'placeholders-idle-left': [
          'placeholders-idle-left-0',
          'placeholders-idle-left-1',
          'placeholders-idle-left-2',
          'placeholders-idle-left-3',
          'placeholders-idle-left-4',
          'placeholders-idle-left-5',
          'placeholders-idle-left-6',
          'placeholders-idle-left-7',
          'placeholders-idle-left-8',
          'placeholders-idle-left-9',
        ],
        'placeholders-idle-top-left': [
          'placeholders-idle-top-left-0',
          'placeholders-idle-top-left-1',
          'placeholders-idle-top-left-2',
          'placeholders-idle-top-left-3',
          'placeholders-idle-top-left-4',
          'placeholders-idle-top-left-5',
          'placeholders-idle-top-left-6',
          'placeholders-idle-top-left-7',
          'placeholders-idle-top-left-8',
          'placeholders-idle-top-left-9',
        ],
        'placeholders-idle-top': [
          'placeholders-idle-top-0',
          'placeholders-idle-top-1',
          'placeholders-idle-top-2',
          'placeholders-idle-top-3',
          'placeholders-idle-top-4',
          'placeholders-idle-top-5',
          'placeholders-idle-top-6',
          'placeholders-idle-top-7',
          'placeholders-idle-top-8',
          'placeholders-idle-top-9',
        ],
      },
    },
  },
  {
    name: 'placeholders-run',
    metadata: {
      frames: {
        'placeholders-run-bottom-0': {
          frame: {
            x: 0,
            y: 600,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-1': {
          frame: {
            x: 120,
            y: 600,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-2': {
          frame: {
            x: 240,
            y: 600,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-3': {
          frame: {
            x: 360,
            y: 600,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-4': {
          frame: {
            x: 480,
            y: 600,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-5': {
          frame: {
            x: 600,
            y: 600,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-6': {
          frame: {
            x: 720,
            y: 600,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-7': {
          frame: {
            x: 840,
            y: 600,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-8': {
          frame: {
            x: 960,
            y: 600,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-9': {
          frame: {
            x: 1080,
            y: 600,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-left-0': {
          frame: {
            x: 0,
            y: 720,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-left-1': {
          frame: {
            x: 120,
            y: 720,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-left-2': {
          frame: {
            x: 240,
            y: 720,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-left-3': {
          frame: {
            x: 360,
            y: 720,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-left-4': {
          frame: {
            x: 480,
            y: 720,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-left-5': {
          frame: {
            x: 600,
            y: 720,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-left-6': {
          frame: {
            x: 720,
            y: 720,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-left-7': {
          frame: {
            x: 840,
            y: 720,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-left-8': {
          frame: {
            x: 960,
            y: 720,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-bottom-left-9': {
          frame: {
            x: 1080,
            y: 720,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-left-0': {
          frame: {
            x: 0,
            y: 840,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-left-1': {
          frame: {
            x: 120,
            y: 840,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-left-2': {
          frame: {
            x: 240,
            y: 840,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-left-3': {
          frame: {
            x: 360,
            y: 840,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-left-4': {
          frame: {
            x: 480,
            y: 840,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-left-5': {
          frame: {
            x: 600,
            y: 840,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-left-6': {
          frame: {
            x: 720,
            y: 840,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-left-7': {
          frame: {
            x: 840,
            y: 840,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-left-8': {
          frame: {
            x: 960,
            y: 840,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-left-9': {
          frame: {
            x: 1080,
            y: 840,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-left-0': {
          frame: {
            x: 0,
            y: 960,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-left-1': {
          frame: {
            x: 120,
            y: 960,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-left-2': {
          frame: {
            x: 240,
            y: 960,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-left-3': {
          frame: {
            x: 360,
            y: 960,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-left-4': {
          frame: {
            x: 480,
            y: 960,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-left-5': {
          frame: {
            x: 600,
            y: 960,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-left-6': {
          frame: {
            x: 720,
            y: 960,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-left-7': {
          frame: {
            x: 840,
            y: 960,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-left-8': {
          frame: {
            x: 960,
            y: 960,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-left-9': {
          frame: {
            x: 1080,
            y: 960,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-0': {
          frame: {
            x: 0,
            y: 1080,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-1': {
          frame: {
            x: 120,
            y: 1080,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-2': {
          frame: {
            x: 240,
            y: 1080,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-3': {
          frame: {
            x: 360,
            y: 1080,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-4': {
          frame: {
            x: 480,
            y: 1080,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-5': {
          frame: {
            x: 600,
            y: 1080,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-6': {
          frame: {
            x: 720,
            y: 1080,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-7': {
          frame: {
            x: 840,
            y: 1080,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-8': {
          frame: {
            x: 960,
            y: 1080,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-run-top-9': {
          frame: {
            x: 1080,
            y: 1080,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
      },
      meta: {
        image: '/sprites/placeholders/placeholders.png',
        size: {
          w: 1200,
          h: 600,
        },
        scale: '1',
      },
      animations: {
        'placeholders-run-bottom': [
          'placeholders-run-bottom-0',
          'placeholders-run-bottom-1',
          'placeholders-run-bottom-2',
          'placeholders-run-bottom-3',
          'placeholders-run-bottom-4',
          'placeholders-run-bottom-5',
          'placeholders-run-bottom-6',
          'placeholders-run-bottom-7',
          'placeholders-run-bottom-8',
          'placeholders-run-bottom-9',
        ],
        'placeholders-run-bottom-left': [
          'placeholders-run-bottom-left-0',
          'placeholders-run-bottom-left-1',
          'placeholders-run-bottom-left-2',
          'placeholders-run-bottom-left-3',
          'placeholders-run-bottom-left-4',
          'placeholders-run-bottom-left-5',
          'placeholders-run-bottom-left-6',
          'placeholders-run-bottom-left-7',
          'placeholders-run-bottom-left-8',
          'placeholders-run-bottom-left-9',
        ],
        'placeholders-run-left': [
          'placeholders-run-left-0',
          'placeholders-run-left-1',
          'placeholders-run-left-2',
          'placeholders-run-left-3',
          'placeholders-run-left-4',
          'placeholders-run-left-5',
          'placeholders-run-left-6',
          'placeholders-run-left-7',
          'placeholders-run-left-8',
          'placeholders-run-left-9',
        ],
        'placeholders-run-top-left': [
          'placeholders-run-top-left-0',
          'placeholders-run-top-left-1',
          'placeholders-run-top-left-2',
          'placeholders-run-top-left-3',
          'placeholders-run-top-left-4',
          'placeholders-run-top-left-5',
          'placeholders-run-top-left-6',
          'placeholders-run-top-left-7',
          'placeholders-run-top-left-8',
          'placeholders-run-top-left-9',
        ],
        'placeholders-run-top': [
          'placeholders-run-top-0',
          'placeholders-run-top-1',
          'placeholders-run-top-2',
          'placeholders-run-top-3',
          'placeholders-run-top-4',
          'placeholders-run-top-5',
          'placeholders-run-top-6',
          'placeholders-run-top-7',
          'placeholders-run-top-8',
          'placeholders-run-top-9',
        ],
      },
    },
  },
  {
    name: 'placeholders-hurt',
    metadata: {
      frames: {
        'placeholders-hurt-bottom-0': {
          frame: {
            x: 0,
            y: 1200,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-1': {
          frame: {
            x: 120,
            y: 1200,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-2': {
          frame: {
            x: 240,
            y: 1200,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-3': {
          frame: {
            x: 360,
            y: 1200,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-4': {
          frame: {
            x: 480,
            y: 1200,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-5': {
          frame: {
            x: 600,
            y: 1200,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-6': {
          frame: {
            x: 720,
            y: 1200,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-7': {
          frame: {
            x: 840,
            y: 1200,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-8': {
          frame: {
            x: 960,
            y: 1200,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-9': {
          frame: {
            x: 1080,
            y: 1200,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-left-0': {
          frame: {
            x: 0,
            y: 1320,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-left-1': {
          frame: {
            x: 120,
            y: 1320,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-left-2': {
          frame: {
            x: 240,
            y: 1320,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-left-3': {
          frame: {
            x: 360,
            y: 1320,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-left-4': {
          frame: {
            x: 480,
            y: 1320,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-left-5': {
          frame: {
            x: 600,
            y: 1320,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-left-6': {
          frame: {
            x: 720,
            y: 1320,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-left-7': {
          frame: {
            x: 840,
            y: 1320,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-left-8': {
          frame: {
            x: 960,
            y: 1320,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-bottom-left-9': {
          frame: {
            x: 1080,
            y: 1320,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-left-0': {
          frame: {
            x: 0,
            y: 1440,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-left-1': {
          frame: {
            x: 120,
            y: 1440,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-left-2': {
          frame: {
            x: 240,
            y: 1440,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-left-3': {
          frame: {
            x: 360,
            y: 1440,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-left-4': {
          frame: {
            x: 480,
            y: 1440,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-left-5': {
          frame: {
            x: 600,
            y: 1440,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-left-6': {
          frame: {
            x: 720,
            y: 1440,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-left-7': {
          frame: {
            x: 840,
            y: 1440,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-left-8': {
          frame: {
            x: 960,
            y: 1440,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-left-9': {
          frame: {
            x: 1080,
            y: 1440,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-left-0': {
          frame: {
            x: 0,
            y: 1560,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-left-1': {
          frame: {
            x: 120,
            y: 1560,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-left-2': {
          frame: {
            x: 240,
            y: 1560,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-left-3': {
          frame: {
            x: 360,
            y: 1560,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-left-4': {
          frame: {
            x: 480,
            y: 1560,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-left-5': {
          frame: {
            x: 600,
            y: 1560,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-left-6': {
          frame: {
            x: 720,
            y: 1560,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-left-7': {
          frame: {
            x: 840,
            y: 1560,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-left-8': {
          frame: {
            x: 960,
            y: 1560,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-left-9': {
          frame: {
            x: 1080,
            y: 1560,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-0': {
          frame: {
            x: 0,
            y: 1680,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-1': {
          frame: {
            x: 120,
            y: 1680,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-2': {
          frame: {
            x: 240,
            y: 1680,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-3': {
          frame: {
            x: 360,
            y: 1680,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-4': {
          frame: {
            x: 480,
            y: 1680,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-5': {
          frame: {
            x: 600,
            y: 1680,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-6': {
          frame: {
            x: 720,
            y: 1680,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-7': {
          frame: {
            x: 840,
            y: 1680,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-8': {
          frame: {
            x: 960,
            y: 1680,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-hurt-top-9': {
          frame: {
            x: 1080,
            y: 1680,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
      },
      meta: {
        image: '/sprites/placeholders/placeholders.png',
        size: {
          w: 1200,
          h: 600,
        },
        scale: '1',
      },
      animations: {
        'placeholders-hurt-bottom': [
          'placeholders-hurt-bottom-0',
          'placeholders-hurt-bottom-1',
          'placeholders-hurt-bottom-2',
          'placeholders-hurt-bottom-3',
          'placeholders-hurt-bottom-4',
          'placeholders-hurt-bottom-5',
          'placeholders-hurt-bottom-6',
          'placeholders-hurt-bottom-7',
          'placeholders-hurt-bottom-8',
          'placeholders-hurt-bottom-9',
        ],
        'placeholders-hurt-bottom-left': [
          'placeholders-hurt-bottom-left-0',
          'placeholders-hurt-bottom-left-1',
          'placeholders-hurt-bottom-left-2',
          'placeholders-hurt-bottom-left-3',
          'placeholders-hurt-bottom-left-4',
          'placeholders-hurt-bottom-left-5',
          'placeholders-hurt-bottom-left-6',
          'placeholders-hurt-bottom-left-7',
          'placeholders-hurt-bottom-left-8',
          'placeholders-hurt-bottom-left-9',
        ],
        'placeholders-hurt-left': [
          'placeholders-hurt-left-0',
          'placeholders-hurt-left-1',
          'placeholders-hurt-left-2',
          'placeholders-hurt-left-3',
          'placeholders-hurt-left-4',
          'placeholders-hurt-left-5',
          'placeholders-hurt-left-6',
          'placeholders-hurt-left-7',
          'placeholders-hurt-left-8',
          'placeholders-hurt-left-9',
        ],
        'placeholders-hurt-top-left': [
          'placeholders-hurt-top-left-0',
          'placeholders-hurt-top-left-1',
          'placeholders-hurt-top-left-2',
          'placeholders-hurt-top-left-3',
          'placeholders-hurt-top-left-4',
          'placeholders-hurt-top-left-5',
          'placeholders-hurt-top-left-6',
          'placeholders-hurt-top-left-7',
          'placeholders-hurt-top-left-8',
          'placeholders-hurt-top-left-9',
        ],
        'placeholders-hurt-top': [
          'placeholders-hurt-top-0',
          'placeholders-hurt-top-1',
          'placeholders-hurt-top-2',
          'placeholders-hurt-top-3',
          'placeholders-hurt-top-4',
          'placeholders-hurt-top-5',
          'placeholders-hurt-top-6',
          'placeholders-hurt-top-7',
          'placeholders-hurt-top-8',
          'placeholders-hurt-top-9',
        ],
      },
    },
  },
  {
    name: 'placeholders-casting',
    metadata: {
      frames: {
        'placeholders-casting-bottom-0': {
          frame: {
            x: 0,
            y: 1800,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-1': {
          frame: {
            x: 120,
            y: 1800,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-2': {
          frame: {
            x: 240,
            y: 1800,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-3': {
          frame: {
            x: 360,
            y: 1800,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-4': {
          frame: {
            x: 480,
            y: 1800,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-5': {
          frame: {
            x: 600,
            y: 1800,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-6': {
          frame: {
            x: 720,
            y: 1800,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-7': {
          frame: {
            x: 840,
            y: 1800,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-8': {
          frame: {
            x: 960,
            y: 1800,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-9': {
          frame: {
            x: 1080,
            y: 1800,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-left-0': {
          frame: {
            x: 0,
            y: 1920,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-left-1': {
          frame: {
            x: 120,
            y: 1920,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-left-2': {
          frame: {
            x: 240,
            y: 1920,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-left-3': {
          frame: {
            x: 360,
            y: 1920,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-left-4': {
          frame: {
            x: 480,
            y: 1920,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-left-5': {
          frame: {
            x: 600,
            y: 1920,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-left-6': {
          frame: {
            x: 720,
            y: 1920,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-left-7': {
          frame: {
            x: 840,
            y: 1920,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-left-8': {
          frame: {
            x: 960,
            y: 1920,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-bottom-left-9': {
          frame: {
            x: 1080,
            y: 1920,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-left-0': {
          frame: {
            x: 0,
            y: 2040,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-left-1': {
          frame: {
            x: 120,
            y: 2040,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-left-2': {
          frame: {
            x: 240,
            y: 2040,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-left-3': {
          frame: {
            x: 360,
            y: 2040,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-left-4': {
          frame: {
            x: 480,
            y: 2040,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-left-5': {
          frame: {
            x: 600,
            y: 2040,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-left-6': {
          frame: {
            x: 720,
            y: 2040,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-left-7': {
          frame: {
            x: 840,
            y: 2040,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-left-8': {
          frame: {
            x: 960,
            y: 2040,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-left-9': {
          frame: {
            x: 1080,
            y: 2040,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-left-0': {
          frame: {
            x: 0,
            y: 2160,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-left-1': {
          frame: {
            x: 120,
            y: 2160,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-left-2': {
          frame: {
            x: 240,
            y: 2160,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-left-3': {
          frame: {
            x: 360,
            y: 2160,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-left-4': {
          frame: {
            x: 480,
            y: 2160,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-left-5': {
          frame: {
            x: 600,
            y: 2160,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-left-6': {
          frame: {
            x: 720,
            y: 2160,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-left-7': {
          frame: {
            x: 840,
            y: 2160,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-left-8': {
          frame: {
            x: 960,
            y: 2160,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-left-9': {
          frame: {
            x: 1080,
            y: 2160,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-0': {
          frame: {
            x: 0,
            y: 2280,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-1': {
          frame: {
            x: 120,
            y: 2280,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-2': {
          frame: {
            x: 240,
            y: 2280,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-3': {
          frame: {
            x: 360,
            y: 2280,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-4': {
          frame: {
            x: 480,
            y: 2280,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-5': {
          frame: {
            x: 600,
            y: 2280,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-6': {
          frame: {
            x: 720,
            y: 2280,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-7': {
          frame: {
            x: 840,
            y: 2280,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-8': {
          frame: {
            x: 960,
            y: 2280,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-casting-top-9': {
          frame: {
            x: 1080,
            y: 2280,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
      },
      meta: {
        image: '/sprites/placeholders/placeholders.png',
        size: {
          w: 1200,
          h: 600,
        },
        scale: '1',
      },
      animations: {
        'placeholders-casting-bottom': [
          'placeholders-casting-bottom-0',
          'placeholders-casting-bottom-1',
          'placeholders-casting-bottom-2',
          'placeholders-casting-bottom-3',
          'placeholders-casting-bottom-4',
          'placeholders-casting-bottom-5',
          'placeholders-casting-bottom-6',
          'placeholders-casting-bottom-7',
          'placeholders-casting-bottom-8',
          'placeholders-casting-bottom-9',
        ],
        'placeholders-casting-bottom-left': [
          'placeholders-casting-bottom-left-0',
          'placeholders-casting-bottom-left-1',
          'placeholders-casting-bottom-left-2',
          'placeholders-casting-bottom-left-3',
          'placeholders-casting-bottom-left-4',
          'placeholders-casting-bottom-left-5',
          'placeholders-casting-bottom-left-6',
          'placeholders-casting-bottom-left-7',
          'placeholders-casting-bottom-left-8',
          'placeholders-casting-bottom-left-9',
        ],
        'placeholders-casting-left': [
          'placeholders-casting-left-0',
          'placeholders-casting-left-1',
          'placeholders-casting-left-2',
          'placeholders-casting-left-3',
          'placeholders-casting-left-4',
          'placeholders-casting-left-5',
          'placeholders-casting-left-6',
          'placeholders-casting-left-7',
          'placeholders-casting-left-8',
          'placeholders-casting-left-9',
        ],
        'placeholders-casting-top-left': [
          'placeholders-casting-top-left-0',
          'placeholders-casting-top-left-1',
          'placeholders-casting-top-left-2',
          'placeholders-casting-top-left-3',
          'placeholders-casting-top-left-4',
          'placeholders-casting-top-left-5',
          'placeholders-casting-top-left-6',
          'placeholders-casting-top-left-7',
          'placeholders-casting-top-left-8',
          'placeholders-casting-top-left-9',
        ],
        'placeholders-casting-top': [
          'placeholders-casting-top-0',
          'placeholders-casting-top-1',
          'placeholders-casting-top-2',
          'placeholders-casting-top-3',
          'placeholders-casting-top-4',
          'placeholders-casting-top-5',
          'placeholders-casting-top-6',
          'placeholders-casting-top-7',
          'placeholders-casting-top-8',
          'placeholders-casting-top-9',
        ],
      },
    },
  },
  {
    name: 'placeholders-cast',
    metadata: {
      frames: {
        'placeholders-cast-bottom-0': {
          frame: {
            x: 0,
            y: 2400,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-1': {
          frame: {
            x: 120,
            y: 2400,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-2': {
          frame: {
            x: 240,
            y: 2400,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-3': {
          frame: {
            x: 360,
            y: 2400,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-4': {
          frame: {
            x: 480,
            y: 2400,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-5': {
          frame: {
            x: 600,
            y: 2400,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-6': {
          frame: {
            x: 720,
            y: 2400,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-7': {
          frame: {
            x: 840,
            y: 2400,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-8': {
          frame: {
            x: 960,
            y: 2400,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-9': {
          frame: {
            x: 1080,
            y: 2400,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-left-0': {
          frame: {
            x: 0,
            y: 2520,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-left-1': {
          frame: {
            x: 120,
            y: 2520,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-left-2': {
          frame: {
            x: 240,
            y: 2520,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-left-3': {
          frame: {
            x: 360,
            y: 2520,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-left-4': {
          frame: {
            x: 480,
            y: 2520,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-left-5': {
          frame: {
            x: 600,
            y: 2520,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-left-6': {
          frame: {
            x: 720,
            y: 2520,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-left-7': {
          frame: {
            x: 840,
            y: 2520,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-left-8': {
          frame: {
            x: 960,
            y: 2520,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-bottom-left-9': {
          frame: {
            x: 1080,
            y: 2520,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-left-0': {
          frame: {
            x: 0,
            y: 2640,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-left-1': {
          frame: {
            x: 120,
            y: 2640,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-left-2': {
          frame: {
            x: 240,
            y: 2640,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-left-3': {
          frame: {
            x: 360,
            y: 2640,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-left-4': {
          frame: {
            x: 480,
            y: 2640,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-left-5': {
          frame: {
            x: 600,
            y: 2640,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-left-6': {
          frame: {
            x: 720,
            y: 2640,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-left-7': {
          frame: {
            x: 840,
            y: 2640,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-left-8': {
          frame: {
            x: 960,
            y: 2640,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-left-9': {
          frame: {
            x: 1080,
            y: 2640,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-left-0': {
          frame: {
            x: 0,
            y: 2760,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-left-1': {
          frame: {
            x: 120,
            y: 2760,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-left-2': {
          frame: {
            x: 240,
            y: 2760,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-left-3': {
          frame: {
            x: 360,
            y: 2760,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-left-4': {
          frame: {
            x: 480,
            y: 2760,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-left-5': {
          frame: {
            x: 600,
            y: 2760,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-left-6': {
          frame: {
            x: 720,
            y: 2760,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-left-7': {
          frame: {
            x: 840,
            y: 2760,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-left-8': {
          frame: {
            x: 960,
            y: 2760,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-left-9': {
          frame: {
            x: 1080,
            y: 2760,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-0': {
          frame: {
            x: 0,
            y: 2880,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-1': {
          frame: {
            x: 120,
            y: 2880,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-2': {
          frame: {
            x: 240,
            y: 2880,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-3': {
          frame: {
            x: 360,
            y: 2880,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-4': {
          frame: {
            x: 480,
            y: 2880,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-5': {
          frame: {
            x: 600,
            y: 2880,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-6': {
          frame: {
            x: 720,
            y: 2880,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-7': {
          frame: {
            x: 840,
            y: 2880,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-8': {
          frame: {
            x: 960,
            y: 2880,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-cast-top-9': {
          frame: {
            x: 1080,
            y: 2880,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
      },
      meta: {
        image: '/sprites/placeholders/placeholders.png',
        size: {
          w: 1200,
          h: 600,
        },
        scale: '1',
      },
      animations: {
        'placeholders-cast-bottom': [
          'placeholders-cast-bottom-0',
          'placeholders-cast-bottom-1',
          'placeholders-cast-bottom-2',
          'placeholders-cast-bottom-3',
          'placeholders-cast-bottom-4',
          'placeholders-cast-bottom-5',
          'placeholders-cast-bottom-6',
          'placeholders-cast-bottom-7',
          'placeholders-cast-bottom-8',
          'placeholders-cast-bottom-9',
        ],
        'placeholders-cast-bottom-left': [
          'placeholders-cast-bottom-left-0',
          'placeholders-cast-bottom-left-1',
          'placeholders-cast-bottom-left-2',
          'placeholders-cast-bottom-left-3',
          'placeholders-cast-bottom-left-4',
          'placeholders-cast-bottom-left-5',
          'placeholders-cast-bottom-left-6',
          'placeholders-cast-bottom-left-7',
          'placeholders-cast-bottom-left-8',
          'placeholders-cast-bottom-left-9',
        ],
        'placeholders-cast-left': [
          'placeholders-cast-left-0',
          'placeholders-cast-left-1',
          'placeholders-cast-left-2',
          'placeholders-cast-left-3',
          'placeholders-cast-left-4',
          'placeholders-cast-left-5',
          'placeholders-cast-left-6',
          'placeholders-cast-left-7',
          'placeholders-cast-left-8',
          'placeholders-cast-left-9',
        ],
        'placeholders-cast-top-left': [
          'placeholders-cast-top-left-0',
          'placeholders-cast-top-left-1',
          'placeholders-cast-top-left-2',
          'placeholders-cast-top-left-3',
          'placeholders-cast-top-left-4',
          'placeholders-cast-top-left-5',
          'placeholders-cast-top-left-6',
          'placeholders-cast-top-left-7',
          'placeholders-cast-top-left-8',
          'placeholders-cast-top-left-9',
        ],
        'placeholders-cast-top': [
          'placeholders-cast-top-0',
          'placeholders-cast-top-1',
          'placeholders-cast-top-2',
          'placeholders-cast-top-3',
          'placeholders-cast-top-4',
          'placeholders-cast-top-5',
          'placeholders-cast-top-6',
          'placeholders-cast-top-7',
          'placeholders-cast-top-8',
          'placeholders-cast-top-9',
        ],
      },
    },
  },
  {
    name: 'placeholders-exhaust',
    metadata: {
      frames: {
        'placeholders-exhaust-bottom-0': {
          frame: {
            x: 0,
            y: 3000,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-1': {
          frame: {
            x: 120,
            y: 3000,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-2': {
          frame: {
            x: 240,
            y: 3000,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-3': {
          frame: {
            x: 360,
            y: 3000,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-4': {
          frame: {
            x: 480,
            y: 3000,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-5': {
          frame: {
            x: 600,
            y: 3000,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-6': {
          frame: {
            x: 720,
            y: 3000,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-7': {
          frame: {
            x: 840,
            y: 3000,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-8': {
          frame: {
            x: 960,
            y: 3000,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-9': {
          frame: {
            x: 1080,
            y: 3000,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-left-0': {
          frame: {
            x: 0,
            y: 3120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-left-1': {
          frame: {
            x: 120,
            y: 3120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-left-2': {
          frame: {
            x: 240,
            y: 3120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-left-3': {
          frame: {
            x: 360,
            y: 3120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-left-4': {
          frame: {
            x: 480,
            y: 3120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-left-5': {
          frame: {
            x: 600,
            y: 3120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-left-6': {
          frame: {
            x: 720,
            y: 3120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-left-7': {
          frame: {
            x: 840,
            y: 3120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-left-8': {
          frame: {
            x: 960,
            y: 3120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-bottom-left-9': {
          frame: {
            x: 1080,
            y: 3120,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-left-0': {
          frame: {
            x: 0,
            y: 3240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-left-1': {
          frame: {
            x: 120,
            y: 3240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-left-2': {
          frame: {
            x: 240,
            y: 3240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-left-3': {
          frame: {
            x: 360,
            y: 3240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-left-4': {
          frame: {
            x: 480,
            y: 3240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-left-5': {
          frame: {
            x: 600,
            y: 3240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-left-6': {
          frame: {
            x: 720,
            y: 3240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-left-7': {
          frame: {
            x: 840,
            y: 3240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-left-8': {
          frame: {
            x: 960,
            y: 3240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-left-9': {
          frame: {
            x: 1080,
            y: 3240,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-left-0': {
          frame: {
            x: 0,
            y: 3360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-left-1': {
          frame: {
            x: 120,
            y: 3360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-left-2': {
          frame: {
            x: 240,
            y: 3360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-left-3': {
          frame: {
            x: 360,
            y: 3360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-left-4': {
          frame: {
            x: 480,
            y: 3360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-left-5': {
          frame: {
            x: 600,
            y: 3360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-left-6': {
          frame: {
            x: 720,
            y: 3360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-left-7': {
          frame: {
            x: 840,
            y: 3360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-left-8': {
          frame: {
            x: 960,
            y: 3360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-left-9': {
          frame: {
            x: 1080,
            y: 3360,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-0': {
          frame: {
            x: 0,
            y: 3480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-1': {
          frame: {
            x: 120,
            y: 3480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-2': {
          frame: {
            x: 240,
            y: 3480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-3': {
          frame: {
            x: 360,
            y: 3480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-4': {
          frame: {
            x: 480,
            y: 3480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-5': {
          frame: {
            x: 600,
            y: 3480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-6': {
          frame: {
            x: 720,
            y: 3480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-7': {
          frame: {
            x: 840,
            y: 3480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-8': {
          frame: {
            x: 960,
            y: 3480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
        'placeholders-exhaust-top-9': {
          frame: {
            x: 1080,
            y: 3480,
            w: 120,
            h: 120,
          },
          sourceSize: {
            w: 120,
            h: 120,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 120,
            h: 120,
          },
        },
      },
      meta: {
        image: '/sprites/placeholders/placeholders.png',
        size: {
          w: 1200,
          h: 600,
        },
        scale: '1',
      },
      animations: {
        'placeholders-exhaust-bottom': [
          'placeholders-exhaust-bottom-0',
          'placeholders-exhaust-bottom-1',
          'placeholders-exhaust-bottom-2',
          'placeholders-exhaust-bottom-3',
          'placeholders-exhaust-bottom-4',
          'placeholders-exhaust-bottom-5',
          'placeholders-exhaust-bottom-6',
          'placeholders-exhaust-bottom-7',
          'placeholders-exhaust-bottom-8',
          'placeholders-exhaust-bottom-9',
        ],
        'placeholders-exhaust-bottom-left': [
          'placeholders-exhaust-bottom-left-0',
          'placeholders-exhaust-bottom-left-1',
          'placeholders-exhaust-bottom-left-2',
          'placeholders-exhaust-bottom-left-3',
          'placeholders-exhaust-bottom-left-4',
          'placeholders-exhaust-bottom-left-5',
          'placeholders-exhaust-bottom-left-6',
          'placeholders-exhaust-bottom-left-7',
          'placeholders-exhaust-bottom-left-8',
          'placeholders-exhaust-bottom-left-9',
        ],
        'placeholders-exhaust-left': [
          'placeholders-exhaust-left-0',
          'placeholders-exhaust-left-1',
          'placeholders-exhaust-left-2',
          'placeholders-exhaust-left-3',
          'placeholders-exhaust-left-4',
          'placeholders-exhaust-left-5',
          'placeholders-exhaust-left-6',
          'placeholders-exhaust-left-7',
          'placeholders-exhaust-left-8',
          'placeholders-exhaust-left-9',
        ],
        'placeholders-exhaust-top-left': [
          'placeholders-exhaust-top-left-0',
          'placeholders-exhaust-top-left-1',
          'placeholders-exhaust-top-left-2',
          'placeholders-exhaust-top-left-3',
          'placeholders-exhaust-top-left-4',
          'placeholders-exhaust-top-left-5',
          'placeholders-exhaust-top-left-6',
          'placeholders-exhaust-top-left-7',
          'placeholders-exhaust-top-left-8',
          'placeholders-exhaust-top-left-9',
        ],
        'placeholders-exhaust-top': [
          'placeholders-exhaust-top-0',
          'placeholders-exhaust-top-1',
          'placeholders-exhaust-top-2',
          'placeholders-exhaust-top-3',
          'placeholders-exhaust-top-4',
          'placeholders-exhaust-top-5',
          'placeholders-exhaust-top-6',
          'placeholders-exhaust-top-7',
          'placeholders-exhaust-top-8',
          'placeholders-exhaust-top-9',
        ],
      },
    },
  },
];
